import React, { useEffect, useRef } from "react";
import cssClasses from "./CancellationPolicy.module.css";
import { useDispatch } from "react-redux";
import actions from "../../Redux Store/actions";
export default function CancellationPolicy() {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(actions.activeMenu("help"));
	}, []);
	return (
		<div className={cssClasses.wrapperPage}>
			<div className={cssClasses.title}>Refund and Cancellation Policy</div>
			<div className={cssClasses.content}>
				Our focus is complete customer satisfaction. In the event, if you are displeased with the services provided, we will refund back the
				money, provided the reasons are genuine and proved after investigation. Please read the fine prints of each deal before taking the
				services.
				<br></br>
				<br></br>
				<div className={cssClasses.title}>Cancellation Policy</div>
				i. In case you desire to cancel the booking an amount mentioned in the Table hereunder written<span style={{ color: "red" }}>
					*
				</span>{" "}
				would be deducted and the balance amount due and payable shall be refunded to you without interest within 45 days from the date of
				receipt of your letter requesting to cancel the said booking.
				<br></br>
				<br></br>
				<table
					border="1"
					cellPadding="10"
					style={{ fontWeight: "bold", borderSpacing: "unset", borderCollapse: "collapse", border: "1px solid #667085", color: "#000" }}
				>
					<thead>
						<tr className={cssClasses.tableRow}>
							<th className={cssClasses.tableCol}>Sr. No.</th>
							<th className={cssClasses.tableCol}>If the letter requesting to cancel the booking is received</th>
							<th className={cssClasses.borderNone}>Amount to be deducted*</th>
						</tr>
					</thead>
					<tbody>
						<tr className={cssClasses.tableRow}>
							<td className={cssClasses.tableCol}>1.</td>
							<td className={cssClasses.tableCol}>Within 15 days from issuance of the allotment letter</td>
							<td className={cssClasses.borderNone}>Nil</td>
						</tr>

						<tr className={cssClasses.tableRow}>
							<td className={cssClasses.tableCol}>2.</td>
							<td className={cssClasses.tableCol}>Within 16 to 30 days from issuance of the allotment letter</td>
							<td className={cssClasses.borderNone}>1% of the cost of the said unit</td>
						</tr>
						<tr className={cssClasses.tableRow}>
							<td className={cssClasses.tableCol}>3.</td>
							<td className={cssClasses.tableCol}>Within 31 to 60 days from issuance of the allotment letter</td>
							<td className={cssClasses.borderNone}>1.5% of the cost of the said unit</td>
						</tr>
						<tr>
							<td className={cssClasses.tableCol}>4.</td>
							<td className={cssClasses.tableCol}>After 61 days from issuance of the allotment letter</td>
							<td className={cssClasses.borderNone}>2% of the cost of the said unit</td>
						</tr>
					</tbody>
				</table>
				<br></br>
				<span style={{ color: "red" }}>*</span>The amount deducted shall not exceed the amount paid by you towards consideration of the said
				unit as mentioned in the table above.
				<br></br>
				<br></br>
				ii.In the event the amount due and payable referred in Clause 7 (i) above is not refunded within 45 days from the date of receipt of
				your letter requesting to cancel the said booking,you shall be entitled to receive the balance amount with interest calculated at the
				rate which shall be the State Bank of India highest Marginal Cost of Lending Rate Plus Two Percent
				<br></br>
				<br></br>
				<div className={cssClasses.title}> Refund Policy</div>
				We will refund the money only in case we fail to provide service to our customers from our end post our internal investigation.
				Applicant need to apply for the same via email at{" "}
				<a href={`https://${process.env.REACT_APP_SUPPORT_EMAIL}`} rel="noreferrer" target={"_blank"}>
					{process.env.REACT_APP_SUPPORT_EMAIL}
				</a>{" "}
				or raise a request via the Customer Porta; Refund will not be provided to the user, once it is earned by the company, because of the
				time and energy invested by our manpower for their work done, which is not returnable. So basically, all the processing fees, payment
				gateway charges, admin fees, and cost of resources for the work done, will be deducted. In short, further, we can’t refund any money
				which is paid to government bodies, such as filing fees or taxes, or to other third parties with a role in processing your order.
				<br></br>
				<br></br>
				<div className={cssClasses.title}>Ungovernable Factors</div>
				The result of a particular process/service cannot be guaranteed as the same involves dependency on Governing Authorities related to
				the said service. This further implies that rejections/ approvals /responses by Govt Authorities or technical issues with Government
				sites including Government backlogs etc. are not within the purview of Online Legal India. These may lead to unexpected delays before
				completion of the process and factors like these are outside our control hence not eligible for refund.
				<br></br>
				<br></br>
				<div className={cssClasses.title}>Force Majeure</div>
				Online Legal India will not be considered responsible if there is a breach of its satisfaction guarantee policy or default under any
				terms of service, and shall not be liable to the Client for any cessation, interruption, or delay in the performance of its
				obligations by reason of earthquake, flood, fire, storm, lightning, drought, landslide, hurricane, cyclone, typhoon, tornado, natural
				disaster, act of God or the public enemy, epidemic, famine or plague, action of a court or public authority, change in law, explosion,
				war, terrorism, armed conflict, labour strike, lockout, boycott or similar event beyond our reasonable control, whether foreseen or
				unforeseen (each a “Force Majeure Event”).
			</div>
		</div>
	);
}
